/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2025-01-03 09:50:04
 */
import { RouteRecordRaw } from 'vue-router'

/** 数据看板 */
const dataCenter: RouteRecordRaw[] = [
  {
    path: '/dataDashboard',
    name: 'DataDashboard',
    component: () => import('@/views/dataDashboard/Index.vue'),
    meta: { title: '首页', requiresAuth: true, keepAlive: true }
  }
]

/** 快件管理 */
const expressManagement: RouteRecordRaw[] = [
  {
    path: '/expressTracking',
    name: 'ExpressTracking',
    component: () => import('@/views/expressTracking/Index.vue'),
    meta: { title: '快件跟踪', requiresAuth: true, keepAlive: true }
  }
]

/** 订单管理 */
const orderManagement: RouteRecordRaw[] = [
  {
    path: '/OrderEntry',
    name: 'OrderEntry',
    component: () => import('@/views/orderEntry/Index.vue'),
    meta: { title: '订单录入', requiresAuth: true, keepAlive: true }
  }
]

/** 客户管理 */
const customManagement: RouteRecordRaw[] = [
  {
    path: '/customManagement',
    name: 'CustomManagement',
    component: () => import('@/views/customManagement/Index.vue'),
    meta: { title: '客户管理', requiresAuth: true, keepAlive: true }
  }
]

/** 订单管理 */
const orderList: RouteRecordRaw[] = [
  {
    path: '/orderList',
    name: 'OrderList',
    component: () => import('@/views/orderList/Index.vue'),
    meta: { title: '订单列表', requiresAuth: true, keepAlive: true }
  }
]
// 资金管理
const capitalList: RouteRecordRaw[] = [
  {
    path: '/sendCommissionReport',
    name: 'SendCommissionReport',
    component: () => import('@/views/send-commission-report/SendCommissionReport.vue'),
    meta: { title: '寄件提成报表', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/performanceReward',
    name: 'PerformanceReward',
    component: () => import('@/views/performance-reward/performanceReward.vue'),
    meta: { title: '冲单激励', requiresAuth: true, keepAlive: true }
  }
]

/** 基础设置 */
const setting: RouteRecordRaw[] = [
  /** 修改密码 */
  {
    path: '/updatePwd',
    name: 'UpdatePwd',
    component: () => import('@/views/updatePwd/Index.vue'),
    meta: { title: '修改密码', requiresAuth: true, keepAlive: true }
  },
  /** 打印设置 */
  {
    path: '/printSetting',
    name: 'PrintSetting',
    component: () => import('@/views/printSetting/Index.vue'),
    meta: { title: '打印设置', requiresAuth: true, keepAlive: true }
  }
]

export { dataCenter, expressManagement, orderManagement, customManagement, orderList, setting, capitalList }
